// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 渐入动画样式 */
.fade-in-section[data-v-6d8b0bbb] {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease-out;
}
.fade-in-section.fade-in-visible[data-v-6d8b0bbb] {
  opacity: 1;
  transform: translateY(0);
}

/* 覆盖点击按钮的过渡效果 */
.click-button[data-v-6d8b0bbb] {
  transition: transform 0.8s ease-out !important;
}

/* 自定义滚动条 */
[data-v-6d8b0bbb]::-webkit-scrollbar {
  width: 4px;
}
[data-v-6d8b0bbb]::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}
[data-v-6d8b0bbb]::-webkit-scrollbar-thumb {
  background: rgba(255, 165, 0, 0.5);
  border-radius: 2px;
}
[data-v-6d8b0bbb] .van-tabbar-item__icon img {
  height: auto;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
